module.exports = __webpack_public_path__ + "assets/vehicle-light.75c16289.svg";